<template>
  <v-card outlined :loading="ordersLoading">
    <v-toolbar flat>
      <v-toolbar-title>{{ $t('message.last_orders') }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>

    <v-simple-table v-if="orders && orders.length > 0">
      <template v-slot:default>
        <tbody>
          <tr
            v-for="item in orders"
            :key="item['@id']"
            style="cursor: pointer;"
            @click="$router.push({ name: 'order', params: { id: item.id } })"
          >
            <td v-if="item.grossTotal > 0" :class="'text-no-wrap status status-' + item.status">
              <v-icon>{{ statusToIcon(item) }}</v-icon>
              <span v-if="$vuetify.breakpoint.smAndUp" class="text-uppercase ml-2">{{
                $t('message.' + item.status)
              }}</span>
            </td>
            <td v-else class="text-no-wrap status status-updated">
              <v-icon>{{ statusToIcon(item) }}</v-icon>
              <span class="text-uppercase ml-2">updated balance</span>
            </td>
            <td class="text-no-wrap">
              <template v-if="$vuetify.breakpoint.smAndUp">
                {{ item.issuedAt | moment('LL') }}
              </template>
              <template v-else>
                {{ item.issuedAt | moment('DD-MM-YYYY') }}
              </template>
            </td>

            <td>
              <div v-if="item.lines.length > 0">
                <span v-for="line in item.lines" :key="line.id">
                  <template v-if="line.type">
                    {{ $t('message.' + line.type) }}
                  </template>
                  <span v-else class="grey--text">{{ $t('message.no_line_type') }}</span>
                </span>
              </div>
            </td>

            <td v-if="$vuetify.breakpoint.smAndUp" class="text-no-wrap">
              <v-icon small color="grey">{{
                typeToIcon(getRelevantPayment(item) ? getRelevantPayment(item).type : 'unpaid')
              }}</v-icon>
              {{ getRelevantPayment(item) ? $t('message.' + getRelevantPayment(item).type) : $t('message.unpaid') }}
            </td>
            <td class="text-right text-no-wrap">
              <template v-if="item.grossTotal > 0">
                {{ $n(item.grossTotal, item.currency.code) }}
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-row v-else-if="orders" justify="center" class="text-center">
      <div class="py-12">
        <v-icon color="grey" size="48" class="mb-1">mdi-cart </v-icon>
        <div class="title grey--text font-weight-regular mb-3">
          {{ $t('message.no_orders_for_this_service') }}
        </div>
      </div>
    </v-row>

    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" text :to="{ name: 'orders' }">
        {{ $t('message.show_full_order_history') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import fetch from '@/utils/fetch'
export default {
  name: 'OrdersSummary',

  props: {
    agreement: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      orders: null,
      ordersLoading: false
    }
  },

  created() {
    this.fetchOrders()
  },

  methods: {
    fetchOrders() {
      this.ordersLoading = true
      fetch('/orders?connectAgreement=' + this.agreement['@id'] + '&itemsPerPage=10&order[issuedAt]=desc')
        .then(response => response.json())
        .then(data => {
          this.orders = data['hydra:member']
          this.ordersLoading = false
        })
        .catch(() => {
          this.ordersLoading = false
        })
    },

    statusToIcon(order) {
      if ('cancelled' === order.status) {
        return 'mdi-cancel'
      }

      if ('expired' === order.status) {
        return 'mdi-timer-off'
      }

      if ('done' === order.status) {
        return 'mdi-thumb-up'
      }

      return 'mdi-account-clock'
    },

    typeToIcon(type) {
      switch (type) {
        case 'credit_card_off_session':
        case 'credit_card_online':
          return 'mdi-credit-card'
        case 'credit_card_offline':
          return 'mdi-point-of-sale'
        case 'direct_debit':
          return 'mdi-receipt'
        case 'transfer':
          return 'mdi-bank'
        case 'airtime_balance':
          return 'mdi-wallet'
        case 'unknown':
          return 'mdi-help-circle-outline'
        case 'express':
          return 'mdi-account-cash'
        default:
          return 'mdi-cancel'
      }
    },

    getRelevantPayment(order) {
      let donePyments = order.payments.filter(payment => {
        return 'done' === payment.status
      })

      if (donePyments.length > 0) {
        return donePyments[0]
      }

      let pendingPyments = order.payments.filter(payment => {
        return 'pending' === payment.status
      })

      if (pendingPyments.length > 0) {
        return pendingPyments[0]
      }

      if (order.payments.length > 0) {
        return order.payments[0]
      }

      return null
    }
  }
}
</script>

<style lang="stylus" scoped>
.status {
    border-left: 8px solid;
}

.status-done {
    border-color: #4CAF50;
    color: #4CAF50;

    .theme--light.v-icon {
        color: #4CAF50;
    }
}

.status-pending {
    border-color: #FF9800;
    color: #FF9800;

    .theme--light.v-icon {
        color: #FF9800;
    }
}

.status-failed {
    border-color: #F44336;
    color: #F44336;

    .theme--light.v-icon {
        color: #F44336;
    }
}

.status-cancelled,
.status-expired {
    border-color: #9E9E9E;
    color: #9E9E9E;

    .theme--light.v-icon {
        color: #9E9E9E;
    }
}
.status-updated{
  border-color: #3b79f5;
  color: #3b79f5;

.theme--light.v-icon {
  color: #3b79f5;
}
}
</style>
